import { FreightConfig, CalculatorSectionType } from "../types/shipment-calculator.type";

export const getFreightConfigs: (
  data: CalculatorSectionType,
) => Record<"Air" | "Sea", FreightConfig> = (data: CalculatorSectionType) => {
  const [airData, seaData] = data.basicBlocks;
  return {
    Air: {
      title: airData.heading,
      subtitle: airData.subheading || "",
      primaryOption: {
        value: "enter-weight",
        title: "Enter Weight",
        description: "I know the weight",
      },
      secondaryOption: {
        value: "estimate-weight",
        title: "Estimate Weight",
        description: "I do not know the weight",
      },
      fieldName: "weight",
      fieldLabel: "Weight in kg",
      placeholder: "Input weight",
    },
    Sea: {
      title: seaData.heading,
      subtitle: seaData.subheading || "",
      primaryOption: {
        value: "enter-cbm",
        title: "Enter CBM",
        description: "I know the actual CBM",
      },
      secondaryOption: {
        value: "calculate-dimension",
        title: "Calculate from dimension",
        description: "I do not know the CBM",
      },
      fieldName: "cbm",
      fieldLabel: "Enter total CBM",
      placeholder: "Input CBM",
    },
  };
};

